import logo from "../assets/logo.png";

export default function Logo({ size = "normal" }) {

  const sizes = {
    normal: {
      image: "h-10",
      title: "text-xl",
      subtitle: "text-xs",
      gap: "gap-3"
    },

    large: {
      image: "h-28",
      title: "text-4xl",
      subtitle: "text-sm",
      gap: "gap-5"
    },

    hero: {
      image: "h-36",
      title: "text-5xl",
      subtitle: "text-base",
      gap: "gap-6"
    }
  };


  const style = sizes[size];


  return (
    <div
      className={`
        flex
        items-center
        ${style.gap}
      `}
    >

      <img
        src={logo}
        alt="Räkna med mig"
        className={`
          ${style.image}
          w-auto
          object-contain
        `}
      />


      <div className="leading-tight">

        <div
          className={`
            ${style.title}
            font-bold
            text-black
            tracking-tight
          `}
        >
          Räkna med mig
        </div>


        <div
          className={`
            ${style.subtitle}
            text-gray-500
            mt-1
          `}
        >
          Jobbcentrum Hudiksvalls kommun
        </div>

      </div>


    </div>
  );
}